
const typedOperators = {
    string: [
        '=',
        '!=',
        'contain',
        'not_contain',
        'start_with',
        'not_start_with',
        'end_with',
        'not_end_with'
    ],
    number: [
        '=',
        '!=',
        '>',
        '<',
        '>=',
        '<=',
        'in_range',
        'in_list',
        'is' //deprecated
    ],
    selectable: [
        'in_list',
        'is'
    ],
};

export default typedOperators;
